import { IOptionsWithTypes } from "@eventr/common";
import { Stack } from "@mui/material";
import { cardTranslation } from "i18n/translateHelpers";
import { useUserFilter } from "../hooks/useUserFilter";
import { CardText } from "../subComponents/cardText";
import { Counter } from "../subComponents/counter";
import { UsersList } from "../subComponents/usersLists";
interface ParkingDriverProps {
  driver: IOptionsWithTypes[];
}

export const ParkingDriver = ({ driver }: ParkingDriverProps) => {
  const { filterUsers } = useUserFilter();
  const count = filterUsers(driver).length;
  return (
    <Stack spacing="8px">
      <Stack direction="row" sx={{
        justifyContent: "space-between"
      }}>
        <CardText variant="bodyBold">{cardTranslation("Driver")}</CardText>
        <Counter count={count} />
      </Stack>
      <UsersList userList={driver} />
    </Stack>
  );
};
